import Box from "@mui/material/Box";
import styles from "features/cancer-protection/step-1/ui/SelectProgram.module.css";
import { colors } from "app/providers/theme/colors-type";
import CustomButton from "shared/custom-button/CustomButton";
import {
  IPrograms,
  IStepOne,
} from "entities/cancer-protection/step-1/types/StepOne-interface";
import { useAppSelector } from "shared/utils/hooks/useRedux";
import { Programs } from "entities/cancer-protection/step-1/selector";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import ModalWidget from "shared/modal/Modal";
import { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

interface ISelectProgramProps {
  formState: Record<string, any>;
  errors: Record<string, string>;
  handleBack: () => void;
  handleNext: () => void;
  handleCheckboxChange: (
    fieldName: keyof IStepOne
  ) => (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  setProgramId: (id: string) => void;
  windowWidth: number;
}

export const SelectProgram: React.FC<ISelectProgramProps> = ({
  formState,
  handleNext,
  handleBack,
  setProgramId,
  windowWidth,
}) => {
  const programs = useAppSelector(Programs);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatNumberWithSpaces = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const handleProgramClick = (programId: string) => {
    setProgramId(programId);
  };

  const [selectedProgram, setSelectedProgram] = useState<IPrograms | null>(
    null
  );
  const handleDesc = (programId: string) => {
    const program = programs.Programs.find((item) => item.ID === programId);
    if (program) {
      setIsModalOpen(true);
      setSelectedProgram(program);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProgram(null);
  };

  useEffect(() => {
    if (programs.Programs.length === 1) {
      setProgramId(programs.Programs[0].ID);
    }
  }, [programs.Programs]);
  return (
    <Box className={styles.desktopContainer}>
      <h2 className={styles.titleStep}>Выберите программу страхования</h2>
      <Box className={styles.cardsBox}>
        {programs.Programs.map((item, index) => (
          <Box
            key={index}
            className={`${styles.itemCard} ${formState.ProgramId === item.ID ? styles.selectedCard : ""}`}
            onClick={() => handleProgramClick(item.ID)}
          >
            <Box className={styles.titleCard}>
              {item.Recommended ? (
                <span className={styles.recommendedCard}>Рекомендуем</span>
              ) : (
                ""
              )}
              {formState.ProgramId === item.ID && (
                <Box className={styles.selectedTab}>
                  <CheckIcon fontSize="small" />
                </Box>
              )}
              <h4>{item.PrintName}</h4>
            </Box>
            <Box className={styles.sumCard}>
              <p>Страховая сумма</p>
              <span>
                {formatNumberWithSpaces(item.InsuranceSum)}{" "}
                <CurrencyRubleIcon fontSize="small" />
              </span>
            </Box>
            <Box className={styles.franCard}>
              <p>
                <span>
                  <AccessTimeIcon />
                </span>
                Есть временная франшиза
              </p>
            </Box>
            <Box className={styles.downCard}>
              <Box className={styles.premiumCard}>
                <p>Стоимость полиса</p>
                <span>
                  {formatNumberWithSpaces(item.InsurancePremium)}{" "}
                  <CurrencyRubleIcon fontSize="small" />
                </span>
              </Box>
              <CustomButton
                title="Подробнее"
                handleClick={() => handleDesc(item.ID)}
                textColor={
                  formState.ProgramId === item.ID ? "white" : colors.primary
                }
                backgroundColor="none"
                border={colors.primary}
                width="150px"
                gap="10px"
                borderRadius="4px"
                padding="3px"
              />
            </Box>
          </Box>
        ))}
      </Box>

      <ModalWidget
        open={isModalOpen}
        handleClose={handleCloseModal}
        title=""
        closeIconPosition="right"
        widthProps={windowWidth < 700 ? 300 : 650}
      >
        {selectedProgram && (
          <Box className={styles.modalBox}>
            <h3>{selectedProgram.PrintName}</h3>
            <Box className={styles.premiumModal}>
              <Box className={styles.premiumModalLine}>
                <p>Страховая сумма</p>
                <span>
                  {formatNumberWithSpaces(selectedProgram.InsuranceSum)}{" "}
                  <CurrencyRubleIcon fontSize="small" />
                </span>
              </Box>
              <Box className={styles.premiumModalLine}>
                <p>Стоимость полиса</p>
                <span className={styles.colorPremium}>
                  {formatNumberWithSpaces(selectedProgram.InsurancePremium)}{" "}
                  <CurrencyRubleIcon fontSize="small" />
                </span>
              </Box>
            </Box>
            {selectedProgram.TerritoryDescription && (
              <Box className={styles.territoryModal}>
                <p className={styles.territoryTitleModal}>Страны лечения</p>
                <span>{selectedProgram.TerritoryDescription}</span>
              </Box>
            )}
            <Box className={styles.descModal}>
              <p className={styles.descTitleModal}>Что входит в программу</p>
              {selectedProgram.Risks.map((itemRisk, index) => (
                <Box className={styles.riskModalLine} key={index}>
                  <p>{itemRisk.RiskName}</p>
                  <span>
                    {formatNumberWithSpaces(itemRisk.InsuranceSum)}{" "}
                    <CurrencyRubleIcon fontSize="small" />
                  </span>
                </Box>
              ))}
            </Box>
            <Box className={styles.franModal}>
              <p className={styles.franTitleModal}>Временная франшиза</p>
              <Box className={styles.franModalLine}>
                <p>Диагностика и лечение злокачественных образований</p>
                <span>90 дней с даты начала срока страхования</span>
              </Box>
              <Box className={styles.franModalLine}>
                <p>Трансплантация костного мозга</p>
                <span>180 дней с даты начала срока страхования</span>
              </Box>
            </Box>
          </Box>
        )}
      </ModalWidget>

      <Box className={styles.btnAllBox}>
        <CustomButton
          title="Назад"
          handleClick={handleBack}
          textColor={colors.primary}
          backgroundColor="none"
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
          border="none"
        />
        {formState.ProgramId && (
          <CustomButton
            title="Продолжить"
            handleClick={handleNext}
            textColor="white"
            backgroundColor={colors.primary}
            width="150px"
            gap="10px"
            borderRadius="4px"
            padding="3px"
          />
        )}
      </Box>
    </Box>
  );
};
